import React, { useRef, useState } from 'react';
import { View, Text, TextInput, TouchableOpacity } from 'react-native';
import ActionSheet, { ActionSheetRef } from 'react-native-actions-sheet';

export type ClockOutSheetRef = {
  show: () => void;
};

type Props = {
  onClockOut: (note?: string) => void;
};

const TasksSheet = React.forwardRef<ClockOutSheetRef, Props>(({ onClockOut }, ref) => {
  const actionSheetRef = useRef<ActionSheetRef>(null);
  const [note, setNote] = useState('');

  React.useImperativeHandle(ref, () => ({
    show: () => {
      setNote('');
      actionSheetRef.current?.show();
    },
  }));

  const handleWithNote = () => {
    onClockOut(note.trim() ? JSON.stringify({ task1: note.trim() }) : undefined);
    actionSheetRef.current?.hide();
  };

  const handleWithoutNote = () => {
    onClockOut(undefined);
    actionSheetRef.current?.hide();
  };

  return (
    <ActionSheet ref={actionSheetRef} containerStyle={{ padding: 20, height: 300 }}>
      <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>Add Activity (optional)</Text>
      <TextInput
        value={note}
        onChangeText={setNote}
        placeholder="What were you working on?"
        placeholderTextColor="#999"
        style={{
          height: 100,
          borderColor: '#ccc',
          borderWidth: 1,
          borderRadius: 10,
          padding: 10,
          textAlignVertical: 'top',
          color: 'black',
          marginBottom: 20,
        }}
        multiline
      />

      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        {/* <TouchableOpacity
          onPress={handleWithoutNote}
          style={{
            flex: 1,
            backgroundColor: '#ccc',
            padding: 12,
            borderRadius: 10,
            marginRight: 10,
            alignItems: 'center',
          }}
        >
          <Text>Clock Out without note</Text>
        </TouchableOpacity> */}

        <TouchableOpacity
          onPress={handleWithNote}
          style={{
            flex: 1,
            backgroundColor: '#4CAF50',
            padding: 12,
            borderRadius: 10,
            marginLeft: 10,
            alignItems: 'center',
          }}
        >
          <Text style={{ color: 'white' }}>Clock Out</Text>
        </TouchableOpacity>
      </View>
    </ActionSheet>
  );
});

export default TasksSheet;